<script setup>

const items = defineModel()

import { Swiper, SwiperSlide } from "swiper/vue";
import { Fancybox } from '@fancyapps/ui';
import { FreeMode, Navigation, Thumbs } from "swiper/modules";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "swiper/swiper-bundle.css";

const modules = ref([FreeMode, Navigation, Thumbs]);

const mainSwiper = ref(null);
const activeIndex = ref(0);
const limitImgIndex = ref(5);

const onSwiper = (swiper) => {
    mainSwiper.value = swiper;
};

const goToSlide = (index) => {
    if (mainSwiper.value) {
        mainSwiper.value.slideTo(index);
    }
};

const onSlideChange = () => {
    if (mainSwiper.value) {
        activeIndex.value = mainSwiper.value.activeIndex;
    }
};



</script>
<template>
    <div>
        <client-only>
            <swiper ref="mainSwiper" :spaceBetween="10" :navigation="true" :modules="[Navigation, Thumbs]"
                class="mySwiper2" @swiper="onSwiper" @slideChange="onSlideChange">
                <swiper-slide  v-for="item in items" :key="item.id">
                    <div>
                        <LayoutsCard :item="item" />
                    </div>
                </swiper-slide>
            </swiper>
        </client-only>
    </div>
</template>